<span>
    {{ 'SHARED.COPYRIGHT' | translate }} © {{ settingsService.getAppSetting('owner') }}, {{ settingsService.getAppSetting('year') }} 
    <span class="url-like" (click)="tpcService.showTermsOfUse = true">  {{ 'SHARED.TERMS_OF_USE' | translate }}</span> |
    <span class="url-like" (click)="tpcService.showPrivacyPolicy = true">{{ 'SHARED.PRIVACY_POLICY' | translate }}</span>
</span>
